import { JiraUser } from '../../types';

export function getDisplayName(user?: JiraUser) {
  if (!user?.active) {
    return 'User not active';
  }
  return user?.displayName || 'User not found';
}
